import React from 'react'
import { CardMedia, Typography } from '@mui/material';


const Home = ({width}) => {

    return ( 
        <div className='color-text mr-0 row'>
            <div className='col-md' data-aos="fade-up">
                <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page1/Asset001.png' className='img-fluid'/>
            </div>
            <div className='col-lg-7 col-md-6 col-12 text-center home-content' data-aos="fade-right">
                <Typography variant={width > 992 ? 'h4' : width > 768 ? 'h5' : width > 480 ? 'h6' : 'body1'} className='home-text' style={{marginBottom: '1%'}}>
                    คุณคิดไว้หรือยังว่า <span className='text-lighting'>อยากใช้ชีวิตหลังเกษียณแบบไหน...</span>
                </Typography>
                <div className='home-highlight-container'>
                    <Typography variant={width > 992 ? 'h5' : width > 768 ? 'h6' : width > 480 ? 'body1' : 'body2'} className='text-bg-border home-highlight'>
                        แล้วเงินที่คุณมีจะเพียงพอใช้ชีวิตหลังเกษียณ<br/>ในแบบที่ต้องการหรือไม่...
                    </Typography>
                </div>
                <Typography variant={width > 992 ? 'h5' : width > 768 ? 'h6' : width > 480 ? 'body1' : 'body2'} className='home-text' style={{marginBottom: '3%'}}>
                    โดยที่ไม่ต้องกังวลว่าเงินจะหมดก่อน หรือ<br/>ใช้จ่ายอย่างยากลำบาก หรือ เป็นภาระลูกหลาน
                </Typography>
                <Typography variant={width > 992 ? 'h5' : width > 768 ? 'h6' : width > 480 ? 'body1' : 'body2'} className='text-lighting home-text' >
                    MLS (Minimum Lump Sum) หรือ<br/>เป้าหมายทางการเงิน ณ เกษียณ
                </Typography>
                <Typography variant={width > 992 ? 'h5' : width > 768 ? 'h6' : width > 480 ? 'body1' : 'body2'} className='home-text'>
                    ใน My Digital Twins เวอร์ชันล่าสุด<br/>ช่วยให้คำตอบกับคุณได้!
                </Typography>
            </div>
            
        </div>
     );
}
 
export default Home;



// import React from "react";
// import { CardMedia, Typography } from "@mui/material";
// import "./home.css";

// const Home = ({ width }) => {
//   return (
//     <div className="home-container">
//       {/* Modern Grid Layout - More Flexible */}
//       <div className="home-grid">
//         {/* Main Image */}
//         <div className="home-main-image" data-aos="fade-up">
//           <img
//             src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page1/Asset001.png"
//             alt="Main GPF Asset"
//             loading="lazy"
//           />
//         </div>
        
//         {/* Side Image */}
//         <div className="home-side-image" data-aos="fade-right">
//           <img
//             src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page1/Asset002.png"
//             alt="GPF Secondary Asset"
//             loading="lazy"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;
